export const SUPPORTED_ENCODING = [
	'US-ASCII',
	'ISO-8859-1',
	'UTF-8',
	'UTF-16BE',
	'UTF-16LE',
	'UTF-16',
];
